/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Es as Es,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ts as Ts,
  rec_bs as bs,
  rec_ws as ws,
  rec_xs as xs,
} from "../../runtime/index.jsx";
export function LogoMarca(e) {
  let t = (0, ReactCompiler.c)(12),
    { title: n, subtitle: r, children: i } = e,
    a;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((a = xs(`PRINCIPAL`, ws)), (t[0] = a))
    : (a = t[0]);
  let o = a,
    s;
  t[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((s = xs(`BANNER`, Ts)), (t[1] = s))
    : (s = t[1]);
  let c = s,
    l,
    u;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((l = {
        backgroundImage: `url(${c})`,
        backgroundSize: `cover`,
        backgroundPosition: `center`,
      }),
      (u = (
        <div
          className={`absolute inset-0 bg-linear-to-t from-black/55 via-black/10 to-black/25`}
        />
      )),
      (t[2] = l),
      (t[3] = u))
    : ((l = t[2]), (u = t[3]));
  let d;
  t[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((d = (
        <div
          className={`relative h-32 w-full sm:h-36`}
          style={l}
          children={[
            u,
            <div
              className={`absolute inset-0 flex items-center justify-center px-6`}
              children={
                <img
                  src={o}
                  alt={bs()}
                  className={`h-10 w-auto brightness-0 invert drop-shadow-md sm:h-11`}
                />
              }
            />,
          ]}
        />
      )),
      (t[4] = d))
    : (d = t[4]);
  let f;
  t[5] !== r || t[6] !== n
    ? ((f = n && (
        <div
          className={`text-center`}
          children={[
            <h2
              className={
                Es(n)
                  ? `font-short-title text-3xl font-medium text-(--text-h)`
                  : `text-2xl font-medium text-(--text-h)`
              }
              children={n}
            />,
            <p className={`mt-1 text-sm text-(--text)`} children={r} />,
          ]}
        />
      )),
      (t[5] = r),
      (t[6] = n),
      (t[7] = f))
    : (f = t[7]);
  let p;
  t[8] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((p = (
        <svg
          viewBox={`0 0 200 12`}
          className={`mx-auto my-5 h-3 w-24`}
          preserveAspectRatio={`none`}
          aria-hidden={`true`}
          children={
            <path
              d={`M0 6 Q 50 12 100 6 T 200 6`}
              fill={`none`}
              stroke={`var(--secondary-gold)`}
              strokeWidth={`2`}
            />
          }
        />
      )),
      (t[8] = p))
    : (p = t[8]);
  let m;
  return (
    t[9] !== i || t[10] !== f
      ? ((m = (
          <div
            className={`animar-fundido fondo-punteado flex min-h-screen items-center justify-center px-4 py-12`}
            children={
              <div
                className={`w-full max-w-lg`}
                children={
                  <div
                    className={`overflow-hidden rounded-[2rem] bg-(--bg) shadow-2xl`}
                    children={[
                      d,
                      <div className={`p-8`} children={[f, p, i]} />,
                    ]}
                  />
                }
              />
            }
          />
        )),
        (t[9] = i),
        (t[10] = f),
        (t[11] = m))
      : (m = t[11]),
    m
  );
}
